import React, { PropTypes } from "react";
import InsurerSection from "./InsurerSection";
import { FormattedMessage } from "react-intl";
import {
  SelectInput,
  TextInput,
  StyledCheckboxInput,
} from "../../../../common/form";
import { Field } from "redux-form";
import { EnumWrapper } from "../../../../../utils/enums";
import { PROVINCES } from "../../../../../utils/enums/enums";

const InsurerGeneralInformation = ({ generateLocalizedFields }) => (
  <InsurerSection
    title={
      <FormattedMessage id="admin.insurers.form.generalInformation.title" />
    }
  >
    {generateLocalizedFields()}
    <Field
      id="address"
      name="address"
      component={TextInput}
      type="text"
      required={true}
      label={
        <FormattedMessage id="admin.insurers.form.generalInformation.address" />
      }
    />
    <Field
      id="city"
      name="city"
      component={TextInput}
      type="text"
      required={true}
      label={
        <FormattedMessage id="admin.insurers.form.generalInformation.city" />
      }
    />
    <EnumWrapper
      enum={PROVINCES}
      query="filters=provinces.countryCode==CA"
      format="inputs"
      prop="options"
    >
      <Field
        id="provinceCode"
        name="provinceCode"
        component={SelectInput}
        addBlankOption={true}
        required={true}
        label={
          <FormattedMessage id="admin.insurers.form.generalInformation.province" />
        }
      />
    </EnumWrapper>
    <Field
      id="postalCode"
      name="postalCode"
      component={TextInput}
      type="text"
      required={true}
      maxLength="10"
      label={
        <FormattedMessage id="admin.insurers.form.generalInformation.postalCode" />
      }
    />
    <Field
      id="emergencyPhoneNumber"
      name="emergencyPhoneNumber"
      component={TextInput}
      type="text"
      maxLength="25"
      label={
        <FormattedMessage id="admin.insurers.form.generalInformation.emergencyPhoneNumber" />
      }
    />
    <Field
      id="website"
      name="website"
      component={TextInput}
      type="text"
      label={
        <FormattedMessage id="admin.insurers.form.generalInformation.website" />
      }
    />
    <Field
      groupClassName="wrapping"
      id="isSelfInsured"
      name="isSelfInsured"
      type="checkbox"
      component={StyledCheckboxInput}
      checkbox={{ value: true }}
      label={
        <FormattedMessage id="admin.insurers.form.generalInformation.selfInsured" />
      }
      normalize={(value) => !!value}
    />
  </InsurerSection>
);

InsurerGeneralInformation.propTypes = {
  initialValues: PropTypes.object,
  generateLocalizedFields: PropTypes.func,
};

export default InsurerGeneralInformation;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/formSections/InsurerGeneralInformation.js